import LayoutActividad from "../../../components/LayoutActividad";
import Discriminacion1 from "../../../images/modulo14/discriminacion1.png";
import Discriminacion2 from "../../../images/modulo14/discriminacion2.png";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";

const Actividad9 = () => {
  const infoUnidad = modulo14.content[2];
  const infoAct = modulo14.content[2].activities[8];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[2].name}: ${modulo14.content[2].activities[9].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[9].path}`,
    titlePrev: `${modulo14.content[2].name}: ${modulo14.content[2].activities[7].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[7].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-4 mt-5 rounded">
        <div className="row align-items-center">
          <div className="col-md-8 p-md-3 p-0">
            <h4 className="mb-4">
              <strong>Discriminación lingüística</strong>
            </h4>
            <p className="mt-1">
              El hecho de que una lengua o variedad tenga más prestigio que
              otras puede traer consecuencias negativas. La principal de estas
              consecuencias es la <strong>discriminación</strong>.
            </p>
          </div>
          <div className="col-md-4">
            <img
              src={Discriminacion1}
              className="bg-white img-fluid rounded"
              alt="Prestigio"
            />
          </div>
          <div className="col-md-4">
            <img
              src={Discriminacion2}
              className="bg-white img-fluid rounded"
              alt="Prestigio"
            />
          </div>
          <div className="col-md-8 p-md-3 p-0">
            <p>
              Este tipo de discriminación se conoce como discriminación
              lingüística y le hace mucho daño a nuestro país. Siempre vamos a
              tener distintas formas de hablar y ello depende de nuestro{" "}
              <strong>origen</strong>, nuestra <strong>educación</strong> o la
              cantidad de <strong>lenguas que hablamos</strong>. La diferencia
              es una riqueza y no una limitación.
            </p>
            <p>
              En ciertas ocasiones, los hablantes de lenguas distintas al
              castellano en el Perú son discriminados. Ello puede ocurrir
              también con hablantes de castellano andino o castellano amazónico.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que lean el texto titulado Discriminación lingüística. Lea
            usted en voz alta, una vez más, el texto. Pregunte por qué se da la
            discriminación lingüística. Retome sus respuestas y comente que las
            variedades de castellano que no cuentan con prestigio suelen ser
            discriminadas. Ello ocurre, por ejemplo, con el castellano andino o
            el castellano amazónico. Lea en voz alta, los globos que aparecen en
            las ilustraciones. Resalte la importancia de rechazar el tipo de
            comentarios y actitudes que presenta la persona que atiende a
            Alejandrina Canchari.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
